import React, { useContext, useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'

import Table from '@components/table'
import Avatar from '@components/avatar'
import IconFilterFields from '@components/table/IconFilterFields'

import { WindowContext } from '@components/windowContextProvider'

import {
  HeaderContainer,
  Text,
  Button,
  DataContainer,
  NameContainer,
} from './styles'

const ProgrammesList = ({
  filterState,
  setFilterState,
  programmes,
  goToProgramme,
}) => {
  const { clientWidth } = useContext(WindowContext)
  const [orderByWithCollection, setOrderByWithCollection] = useState('')

  const setOrderBy = (field) => {
    if (!filterState[field]) {
      setFilterState({ ...filterState, [field]: 'desc' })
    } else if (filterState[field] === 'desc') {
      setFilterState({ ...filterState, [field]: 'asc' })
    } else {
      setFilterState({ ...filterState, [field]: null })
    }
  }

  const setOrderByState = () => {
    if (!orderByWithCollection) {
      setOrderByWithCollection('desc')
    } else if (orderByWithCollection === 'desc') {
      setOrderByWithCollection('asc')
    } else {
      setOrderByWithCollection('')
    }
  }

  const orderProgramme = (value) => {
    if (!value) return value
    if (orderByWithCollection === 'asc') {
      return value.sort(
        (a, b) => a.totalBeneficiariesWithCollection - b.totalBeneficiariesWithCollection
      )
    }
    if (orderByWithCollection === 'desc') {
      return value.sort(
        (a, b) => b.totalBeneficiariesWithCollection - a.totalBeneficiariesWithCollection
      )
    }
    return value
  }

  const removeTableItemOnWidth = (arr) => {
    if (clientWidth <= 900) arr.splice(3, 1)
    if (clientWidth <= 700) arr.splice(2, 1)
    if (clientWidth <= 560) arr.splice(1, 1)
  }

  const dataHeads = [
    <HeaderContainer onClick={() => setOrderBy('orderByName')}>
      <IconFilterFields orderBy={filterState.orderByName} />
      Programa
    </HeaderContainer>,
    <HeaderContainer onClick={() => setOrderBy('orderByBeneficiaryNumber')}>
      <IconFilterFields orderBy={filterState.orderByBeneficiaryNumber} />
      BENEFICIÁRIOS
    </HeaderContainer>,
    <HeaderContainer onClick={() => setOrderByState()}>
      <IconFilterFields orderBy={orderByWithCollection} />
      PARTICIPANTES
    </HeaderContainer>,
    <HeaderContainer onClick={() => setOrderBy('orderByLastCollectionDay')}>
      <IconFilterFields orderBy={filterState.orderByLastCollectionDay} />
      ÚLTIMA COLETA
    </HeaderContainer>,
    'DETALHES',
  ]

  removeTableItemOnWidth(dataHeads)

  const data = _.map(orderProgramme(programmes), (programme) => {
    const {
      name,
      totalBeneficiaries,
      lastCollectionDay,
      totalBeneficiariesWithCollection,
    } = programme
    const row = [
      <DataContainer>
        <NameContainer>
          <Avatar name={name} />
          <Text style={{ paddingLeft: 16 }}>{name}</Text>
        </NameContainer>
      </DataContainer>,
      <DataContainer>
        <Text>{totalBeneficiaries}</Text>
      </DataContainer>,
      <DataContainer>
        <Text>{totalBeneficiariesWithCollection}</Text>
      </DataContainer>,
      <DataContainer>
        <Text>{lastCollectionDay}</Text>
      </DataContainer>,
      <DataContainer>
        <Button onClick={() => goToProgramme(programme)}>Acessar</Button>
      </DataContainer>,
    ]
    removeTableItemOnWidth(row)

    return row
  })

  return (
    <Table
      headline
      dataHeads={dataHeads}
      data={data}
      dataWidth={['20%', '20%', '20%', '20%', '20%']}
    />
  )
}

ProgrammesList.propTypes = {
  orderByName: PropTypes.string,
  filterState: PropTypes.object.isRequired,
  setFilterState: PropTypes.func.isRequired,
  programmes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      totalBeneficiaries: PropTypes.number,
      lastCollectionDay: PropTypes.string,
    })
  ),
  goToProgramme: PropTypes.func.isRequired,
}

ProgrammesList.defaultProps = {
  orderByName: '',
  programmes: null,
}

export default ProgrammesList
